import { useEffect } from 'react';

export const useOutsideClick = (isOpen, inputRef, dropdownRef, onClose) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleClickOutside = (e) => {
            if (inputRef.current?.contains(e.target) || dropdownRef.current?.contains(e.target)) {
                return;
            }
            onClose();
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchstart', handleClickOutside, { passive: true });

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside, { passive: true });
        };
    }, [isOpen, onClose, inputRef, dropdownRef]);
};
